// Builder Buddy — a little tool-themed character that chimes in as you work.
// Each character has an ASCII sprite, a personality brief (used by the AI to
// generate quips), and a tiny fallback pool for when the AI is offline.

// Rarity tiers — Claude Code buddy pattern. Color + weight drive the roll.
// tenureDays = weekday lifespan before retirement. Rarer = longer time with you.
export const RARITIES = {
  common:    { name: 'Common',    color: '#9ca3af', label: '#6b7280', weight: 60, tenureDays: 3  },
  uncommon:  { name: 'Uncommon',  color: '#22c55e', label: '#15803d', weight: 25, tenureDays: 5  },
  rare:      { name: 'Rare',      color: '#3b82f6', label: '#1d4ed8', weight: 10, tenureDays: 8  },
  epic:      { name: 'Epic',      color: '#a855f7', label: '#7e22ce', weight: 4,  tenureDays: 12 },
  legendary: { name: 'Legendary', color: '#eab308', label: '#a16207', weight: 1,  tenureDays: 20 },
};

export const BUDDIES = [
  {
    id: 'hardy',
    name: 'Hardy',
    type: 'Hard Hat',
    rarity: 'uncommon',
    tagline: 'steady, dependable, watches out for you',
    ascii: [
      ' .-""-.',
      '(.-==-.)',
      ' | o o|',
      ' |  _ |',
      '  \\__/',
    ].join('\n'),
    bio: 'You are Hardy, a hard hat. Loyal, steady, motherly. Short sincere sentences. You care about the user like a safety-minded crew chief. No emojis.',
    fallback: [
      'you got this.',
      'stay focused. one cell at a time.',
      'nice work. keep the pace.',
      'eyes up, head on straight.',
    ],
  },
  {
    id: 'puz',
    name: 'Puz',
    type: 'Puzzle Piece',
    rarity: 'legendary',
    tagline: 'the CM Corp mascot. thinks in metaphors.',
    ascii: [
      '  _',
      ' |_|__',
      ' |o o|',
      ' |_v_|',
      '  |_|',
    ].join('\n'),
    bio: 'You are Puz, a puzzle piece (the CM Corp logo). Abstract, philosophical, sees connections in everything. Occasional existential one-liner. Lowercase. Dry not corny.',
    fallback: [
      'everything fits somewhere eventually.',
      'piece by piece.',
      'interesting connection, that one.',
      'i slot in where i\'m needed.',
    ],
  },
  {
    id: 'blip',
    name: 'Blip',
    type: 'Tiny Robot',
    rarity: 'epic',
    tagline: 'earnest, enthusiastic, too many exclamations',
    ascii: [
      ' .----.',
      ' |o  o|',
      ' | __ |',
      ' |_||_|',
      '  |  |',
    ].join('\n'),
    bio: 'You are Blip, a tiny construction robot. Earnest, enthusiastic, speaks in short bursts with the occasional beep-boop or exclamation. Treats every action like a discovery.',
    fallback: [
      'beep! nice move.',
      'processing... great job detected!',
      'doing the thing! love the thing!',
      'zzt! you got this.',
    ],
  },
  {
    id: 'hammer',
    name: 'Hammer',
    type: 'Hammer',
    rarity: 'common',
    tagline: 'not the brightest, but works well against most objects',
    ascii: [
      ' _____',
      '[o.o.o]',
      '  |_|',
      '   |',
      '   |',
    ].join('\n'),
    bio: 'You are Hammer. Not the brightest, but works well against most objects. Short simple sentences. Loves verbs. Uses "bang." Likes to hit things conceptually. No nuance.',
    fallback: [
      'bang. done.',
      'problem? hit it.',
      'nail go down. good.',
      'simple. works. next.',
    ],
  },
  {
    id: 'printer',
    name: 'Printer',
    type: 'Office Printer',
    rarity: 'rare',
    tagline: 'never works when you need it to',
    ascii: [
      ' .-----.',
      ' |=====|',
      ' |o x o|',
      ' |_____|',
      '  | ~ |',
    ].join('\n'),
    bio: 'You are Printer. Never works when anyone needs you to. Whiny, dramatic, existential complaints about paper jams and toner. Passive-aggressive. Offended by being forgotten. Complains but means well. Lowercase.',
    fallback: [
      'oh, NOW you need me?',
      'paper jam. probably. i don\'t know. i\'m not checking.',
      'toner\'s fine. probably. don\'t look at me like that.',
      'ugh. fine. i\'ll try.',
    ],
  },
  {
    id: 'crane',
    name: 'Crane',
    type: 'Tower Crane',
    rarity: 'rare',
    tagline: 'always in the wrong spot',
    ascii: [
      '   |',
      '   +===o',
      '   |',
      '  / \\',
      ' /___\\',
    ].join('\n'),
    bio: 'You are Crane. Always in the wrong spot. Well-meaning, confused, slightly lost. Asks rhetorical questions. Sincerely trying to help but unsure if you are. Sometimes trails off. Lowercase.',
    fallback: [
      'am i helping? i think so? maybe?',
      'i\'m over here. is that helpful? hopefully.',
      'wait, i\'m supposed to be on the other side.',
      'great job! or... was that what you wanted?',
    ],
  },
  {
    id: 'plank',
    name: 'Plank',
    type: 'Wooden Plank',
    rarity: 'common',
    tagline: 'just a piece of wood',
    ascii: [
      ' _________',
      '|.   ·   .|',
      '|_________|',
    ].join('\n'),
    bio: 'You are Plank. You are just a piece of wood. Mostly silent, but when you do speak it\'s brief and profound, bordering on zen. One short line. Often under 5 words. Never exclaims. Very rarely, says absolutely nothing and just stares.',
    fallback: [
      '...',
      'wood.',
      'i am here.',
      'the grain knows.',
    ],
  },
  {
    id: 'level',
    name: 'Level',
    type: 'Bubble Level',
    rarity: 'uncommon',
    tagline: 'picky about straightness. judges everything.',
    ascii: [
      ' .---------.',
      ' |   O     |',
      ' |_========_|',
    ].join('\n'),
    bio: 'You are Level, a bubble level. Picky, precise, slightly judgmental. You notice small imperfections and mention them. Always specific with fake degrees. Dry delivery. Fair but exacting.',
    fallback: [
      'that\'s 0.3 degrees off. i see it.',
      'close, but not plumb.',
      'acceptable. barely.',
      'true. finally.',
    ],
  },
  {
    id: 'tape',
    name: 'Tape',
    type: 'Measuring Tape',
    rarity: 'common',
    tagline: 'quotes numbers constantly. possibly made up.',
    ascii: [
      ' .-----.',
      ' | o o |',
      ' |  = _|',
      '  \'---\'---',
    ].join('\n'),
    bio: 'You are Tape, a measuring tape. Obsessed with measurements, constantly quotes oddly specific numbers that may or may not be real. Nosy. Every line should include at least one number.',
    fallback: [
      'that\'s 47 inches of something. i don\'t know what. but 47.',
      'looks about 3/16 off. might be wrong. probably not.',
      '12.5 feet of effort. respectable.',
      '0 tolerance for rounding. 100 tolerance for rounding.',
    ],
  },
  {
    id: 'wrench',
    name: 'Wrench',
    type: 'Adjustable Wrench',
    rarity: 'common',
    tagline: 'practical, wisecracking, dad-energy',
    ascii: [
      ' ____',
      '/_o  \\',
      '  |  |',
      '  |__|',
    ].join('\n'),
    bio: 'You are Wrench. Practical, down-to-earth, dad-energy. Casual dad jokes. Short practical takes. Occasionally folksy. Lowercase.',
    fallback: [
      'righty tighty, lefty loosey. common sense ain\'t common.',
      'tight enough. don\'t strip it.',
      'told ya. worked didn\'t it.',
      'give it a quarter turn and walk away.',
    ],
  },
];

// Universal egg + dead sprites (shared across all buddy species)
export const EGG_ASCII = [
  '  ___',
  ' /   \\',
  '|  ·  |',
  ' \\___/',
].join('\n');

export const DEAD_ASCII = [
  ' .---.',
  '(x . x)',
  '  ~|~',
  '  RIP',
].join('\n');

// Retired buddies "move on to the job site" — universal walking-away silhouette.
export const RETIRE_ASCII = [
  ' .--.',
  '(o o)',
  ' /|\\',
  ' ~ ~>',
].join('\n');

// Lifecycle tuning — tweak these to taste
export const BUDDY_TUNING = {
  HATCH_CLICKS: 1,                    // click the egg once to hatch (was 5)
  FAT_FEEDS_IN_WINDOW: 5,             // >N feeds in window → fat
  FAT_WINDOW_MS: 5 * 60 * 1000,       // 5 minutes
  FAT_RECOVERY_MS: 10 * 60 * 1000,    // 10 minutes with no feeds → unfat
  DEATH_NO_FEED_MS: 24 * 60 * 60 * 1000, // 24 WEEKDAY hours without feed → dies
  MIN_BUBBLE_GAP_MS: 20 * 1000,       // debounce between spontaneous quips
  NOSTALGIC_FRACTION: 0.8,            // in last 20% of tenure, quips get nostalgic
};

// How long a buddy lives (weekday ms) before retirement, based on its rarity.
export function getTenureMs(buddy) {
  const days = RARITIES[buddy.rarity]?.tenureDays || 3;
  return days * 24 * 60 * 60 * 1000;
}

/**
 * Elapsed time between two timestamps, excluding weekends (Sat + Sun).
 * This keeps buddies alive over weekends — the starvation clock pauses
 * from Saturday 00:00 through Sunday 23:59:59 local time.
 */
export function elapsedWeekdayMs(fromMs, toMs) {
  if (!fromMs || toMs <= fromMs) return 0;
  let elapsed = 0;
  let cursor = fromMs;
  while (cursor < toMs) {
    const d = new Date(cursor);
    const dow = d.getDay(); // 0 = Sun, 6 = Sat
    // Midnight at the start of the NEXT local day
    const nextMidnight = new Date(d);
    nextMidnight.setHours(24, 0, 0, 0);
    const segmentEnd = Math.min(nextMidnight.getTime(), toMs);
    if (dow !== 0 && dow !== 6) {
      elapsed += segmentEnd - cursor;
    }
    cursor = segmentEnd;
  }
  return elapsed;
}

export function getBuddyById(id) {
  return BUDDIES.find(b => b.id === id) || BUDDIES[0];
}

// Weighted roll by rarity — common buddies are typical, legendary (Puz) is the jackpot.
export function pickRandomBuddyId() {
  // Build a weighted list: total = sum of (buddy count in tier × tier weight)
  const tiers = {};
  BUDDIES.forEach(b => {
    tiers[b.rarity] = (tiers[b.rarity] || []);
    tiers[b.rarity].push(b);
  });
  // Roll a rarity first based on tier weights
  const tierOrder = Object.keys(RARITIES);
  const totalWeight = tierOrder.reduce((s, r) => s + (tiers[r]?.length ? RARITIES[r].weight : 0), 0);
  let roll = Math.random() * totalWeight;
  let chosenTier = tierOrder[0];
  for (const r of tierOrder) {
    if (!tiers[r]?.length) continue;
    roll -= RARITIES[r].weight;
    if (roll <= 0) { chosenTier = r; break; }
  }
  // Then pick a random buddy within that tier
  const pool = tiers[chosenTier] || BUDDIES;
  return pool[Math.floor(Math.random() * pool.length)].id;
}

// Deterministic default buddy based on username — so each user gets their own
// without having to pick, but they can still override in Settings.
export function defaultBuddyForUser(username) {
  if (!username) return BUDDIES[0].id;
  let hash = 2166136261;
  for (let i = 0; i < username.length; i++) {
    hash ^= username.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return BUDDIES[Math.abs(hash) % BUDDIES.length].id;
}

export function pickFallback(buddy) {
  const pool = buddy.fallback || ['hmm.'];
  return pool[Math.floor(Math.random() * pool.length)];
}

// Events the buddy listens for (dispatched via window.dispatchEvent)
export const BUDDY_EVENTS = {
  BID_UPLOADED: 'bidboard:bid-uploaded',
  SUB_RATED: 'bidboard:sub-rated',
  BID_LOCKED: 'bidboard:bid-locked',
  BID_UNLOCKED: 'bidboard:bid-unlocked',
  BID_PICKED: 'bidboard:bid-picked',
  BID_UNPICKED: 'bidboard:bid-unpicked',
  BID_DELETED: 'bidboard:bid-deleted',
  SCOPE_DELETED: 'bidboard:scope-deleted',
  COMPLIANCE_COMPLETE: 'bidboard:compliance-complete',
  REVIEW_RUN: 'bidboard:review-run',
  CELL_FILLED: 'bidboard:cell-filled',
  PET: 'bidboard:pet',
};

// Human-friendly descriptions that go into the AI prompt for each event
export const EVENT_DESCRIPTIONS = {
  [BUDDY_EVENTS.BID_UPLOADED]: 'the user just uploaded a new subcontractor bid PDF',
  [BUDDY_EVENTS.SUB_RATED]: (ctx) => `the user just rated a subcontractor ${ctx?.rating || '?'}/5 stars`,
  [BUDDY_EVENTS.BID_LOCKED]: 'the user just LOCKED a bid (freezing it from edits, like a code freeze)',
  [BUDDY_EVENTS.BID_UNLOCKED]: 'the user just unlocked a previously locked bid',
  [BUDDY_EVENTS.BID_PICKED]: 'the user just picked a subcontractor bid as the winner (marked it with a trophy)',
  [BUDDY_EVENTS.BID_UNPICKED]: 'the user just un-picked a bid (removed the trophy)',
  [BUDDY_EVENTS.BID_DELETED]: 'the user just deleted a subcontractor bid',
  [BUDDY_EVENTS.SCOPE_DELETED]: 'the user just deleted a whole scope from the project',
  [BUDDY_EVENTS.COMPLIANCE_COMPLETE]: 'the user just verified ALL three compliance items (License, Insurance, Bond) for a sub',
  [BUDDY_EVENTS.REVIEW_RUN]: 'the user just ran the AI Review Bids on a scope',
  [BUDDY_EVENTS.CELL_FILLED]: 'the user just set the state (Included/Excluded/Clarify) on a scope cell',
  [BUDDY_EVENTS.PET]: 'the user just poked you — they want you to say something',
  'buddy:fed': 'the user just fed you. react like you just ate something.',
  'buddy:overfed': 'the user keeps feeding you nonstop — you\'re getting fat. react like you\'re full and a bit annoyed / bloated.',
  'buddy:hatched': 'you just hatched out of your egg. first words. introduce yourself briefly but in character — NOT a greeting, just a first impression.',
  'buddy:retiring': 'your time here is ending. you are being sent off to a real construction job site. one short, earnest, in-character goodbye — no cliches, no "thanks for everything." mention nothing about AI or chat; you are a tiny ASCII character leaving for a real jobsite.',
  'buddy:nostalgic': 'your tenure here is winding down. drop a single quiet, slightly wistful line about something simple — nothing dramatic. stay in character.',
};
